<template>
  <div class="p-5">
    <h2 class="text-center text-gray-500" v-text="message"></h2>
    <div class="flex justify-center items-center text-6xl py-12 text-gray-200">
      <font-awesome-icon :icon="['fas', 'cog']" spin></font-awesome-icon>
    </div>
  </div>
</template>

<script>
export default {
  props: ["message"],
};
</script>
